import React, { useState, useEffect, useRef } from "react";
import {
  Box,
  Checkbox,
  FormControlLabel,
  FormGroup,
  Switch,
} from "@mui/material";
import { images } from "../../config/images";
import SearchIcon from "@mui/icons-material/Search";
import ClearIcon from "@mui/icons-material/Clear";
import { useSelector } from "react-redux";
import TimeDatePicker from "../DatePicker/DatePicker";
import MapComponent from "./MapComponent";
import OpenInFullIcon from "@mui/icons-material/OpenInFull";
import CloseFullscreenIcon from "@mui/icons-material/CloseFullscreen";
import dayjs from "dayjs";
import "./Map.css";
import ClickAwayListener from "@mui/material/ClickAwayListener";
import { Button } from "../Button/button";
import {
  getLocationsForMap,
  getProduct,
  getScannedPipesCount,
  getTracking,
  getUserRoleList,
} from "../../container/Pipes/services";
import { notifyError } from "../ToastNotification/ToastNotification";

const MapContainer = ({
  startDateReFormat,
  setStartDateReFormat,
  endDateReFormat,
  setEndDateReFormat,
  setGetPipesData,
  setProductId,
  showTime,
  setShowTime,
  roleList,
}) => {
  const [isSolarFullScreen, setIsSolarFullScreen] = useState(false);
  const { isFullscreen } = useSelector((state) => state.headerState);

  const [locationSearch, setLocationSearch] = useState("");
  const [isFilterOpen, setIsFilterOpen] = useState(false);
  const [product, setProduct] = useState([]);
  const [selectedBoxes, setSelectedBoxes] = useState(["distributor", "plants"]);
  const [selectedScanBoxes, setSelectedScanBoxes] = useState([3, 2, 1]);
  const [selectedDevices, setSelectedDevices] = useState([0, 1]);
  const [pipesData, setPipesData] = useState([]);
  const [selectedProductIds, setSelectedProductIds] = useState([]);
  const [selectRoleId, setRoleId] = useState([]);
  const [locationAPIData, setLocationAPIData] = useState([]);
  const [supplyChain, setSupplyChain] = useState([]);
  const [debouncedText, setDebouncedText] = useState("");

  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedText(locationSearch);
    }, 500); // wait for 500ms after typing stops

    return () => {
      clearTimeout(handler); // cancel on every new keystroke
    };
  }, [locationSearch]);

  const startDateData = dayjs(startDateReFormat).format("YYYY-MM-DD HH:mm:ss");
  const endDateData = dayjs(endDateReFormat).format("YYYY-MM-DD HH:mm:ss");

  const startDateData1 = dayjs(startDateReFormat).format("YYYY-MM-DD");
  const endDateData1 = dayjs(endDateReFormat).format("YYYY-MM-DD");
  const [UIDSearchData, setUIDSearchData] = useState([]);

  useEffect(() => {
    setGetPipesData(pipesData);
  }, [pipesData]);

  useEffect(() => {
    if (roleList?.length) {
      setRoleId(roleList.map((role) => role.id));
    }
  }, [roleList]);

  useEffect(() => {
    if (product?.length > 0) {
      setSelectedProductIds([product[0].id]); // initialize with first ID
      setProductId([product[0].id]); // keep this if needed
    }
  }, [product]);

  const handleFilterChangeData = (id) => (event) => {
    setSelectedDevices((prev) => {
      if (!Array.isArray(prev)) {
        prev = [];
      }

      if (event.target.checked) {
        return [...prev, id];
      } else {
        return prev.filter((deviceId) => deviceId !== id);
      }
    });
  };
const mapRef = useRef(null);

  useEffect(() => {
    handleProductData();
  }, []);

  const handleProductData = async () => {
    try {
      const resp = await getProduct();
      if (resp.status == 200 || resp.status == 201) {
        const productList = resp.data.payload;
        setProduct(productList);
      }
    } catch (error) {
      setProduct([]);
    }
  };
 
  const [originalHeight, setOriginalHeight] = useState(null);

  useEffect(() => {
    const mapContainer = document.getElementById("map-container");
    if (!mapContainer) return;
  
    // Store original height when component mounts
    const containerHeight = mapContainer.offsetHeight;
    setOriginalHeight(containerHeight);
    console.log("Stored original height:", containerHeight);
  
    const handleFullscreenChange = () => {
      if (document.fullscreenElement === mapContainer) {
        // Entering fullscreen
        setIsSolarFullScreen(true);
      } else {
        // Exiting fullscreen
        setIsSolarFullScreen(false);
        
        // Restore original height with a small delay
        setTimeout(() => {
          if (originalHeight) {
            mapContainer.style.height = `${originalHeight}px`;
            console.log("Restored height to:", originalHeight);
            
            // Trigger map resize if using Mappls/MapmyIndia
            if (window.mappls && mapRef.current) {
              setTimeout(() => {
                window.mappls.event.trigger(mapRef.current, 'resize');
              }, 100);
            }
          }
        }, 100); // Small delay to ensure DOM update
      }
    };
  
    // Add all fullscreen event listeners
    document.addEventListener("fullscreenchange", handleFullscreenChange);
    document.addEventListener("webkitfullscreenchange", handleFullscreenChange);
    document.addEventListener("MSFullscreenChange", handleFullscreenChange);
  
    return () => {
      document.removeEventListener("fullscreenchange", handleFullscreenChange);
      document.removeEventListener("webkitfullscreenchange", handleFullscreenChange);
      document.removeEventListener("MSFullscreenChange", handleFullscreenChange);
    };
  }, [originalHeight]); // Add originalHeight to dependencies
  
  const toggleFullscreen = () => {
    const mapContainer = document.getElementById("map-container");
    if (!mapContainer) return;
  
    if (!document.fullscreenElement) {
      // Store current height before entering fullscreen
      const currentHeight = mapContainer.offsetHeight;
      setOriginalHeight(currentHeight);
      console.log("Storing height before fullscreen:", currentHeight);
  
      // Enter fullscreen
      setIsSolarFullScreen(true);
      try {
        if (mapContainer.requestFullscreen) {
          mapContainer.requestFullscreen();
        } else if (mapContainer.webkitRequestFullscreen) {
          mapContainer.webkitRequestFullscreen();
        } else if (mapContainer.msRequestFullscreen) {
          mapContainer.msRequestFullscreen();
        }
      } catch (error) {
        console.error("Fullscreen request failed:", error);
        setIsSolarFullScreen(false);
      }
    } else {
      // Exit fullscreen
      setIsSolarFullScreen(false);
      try {
        if (document.exitFullscreen) {
          document.exitFullscreen();
        } else if (document.webkitExitFullscreen) {
          document.webkitExitFullscreen();
        } else if (document.msExitFullscreen) {
          document.msExitFullscreen();
        }
      } catch (error) {
        console.error("Fullscreen exit failed:", error);
        setIsSolarFullScreen(true);
      }
    }
  };

  const handleFilterClick = () => {
    setIsFilterOpen(!isFilterOpen);
  };
  const handleSupplyChainClick = (type) => {
    // Toggle logic: add if not present, remove if already there
    setSelectedBoxes((prev) =>
      prev.includes(type)
        ? prev.filter((item) => item !== type)
        : [...prev, type]
    );
  };
  const handleScanResult = (type) => {
    setSelectedScanBoxes((prev) =>
      prev.includes(type)
        ? prev.filter((item) => item !== type)
        : [...prev, type]
    );
  };

  const handleFilterChange = (id) => (event) => {
    if (event.target.checked) {
      setSelectedProductIds((prev) => [...prev, id]);
    } else {
      setSelectedProductIds((prev) => prev.filter((itemId) => itemId !== id));
    }
  };

  const handleFilterRoleChange = (id) => (event) => {
    setRoleId((prev) => {
      if (event.target.checked) {
        return [...prev, id];
      } else {
        return prev.filter((productId) => productId !== id);
      }
    });
  };
  const handleToggleTime = () => {
    setShowTime(!showTime);
  };

  const handleStartDate = (newStartDate) => {
    setStartDateReFormat(newStartDate);
  };

  const handleEndDate = (newEndDate) => {
    if (newEndDate === null || !newEndDate.isValid()) {
      setEndDateReFormat(null);
    } else {
      if (showTime) {
        setEndDateReFormat(newEndDate);
      } else {
        // Set the end date to 23:59:00 if time is not shown
        setEndDateReFormat(dayjs(newEndDate).hour(23).minute(59).second(0));
      }
    }
  };

  // useEffect(() => {
  //   if (!UIDSearchData?.uid) {
  //     console.log("sakdjkasjdbasbj");
  //     setLocationSearch("");
  //   }
  // }, [UIDSearchData]);

  const handleClearSearch = () => {
    setLocationSearch("");
  };

  useEffect(() => {
    if (selectedProductIds.length > 0 && startDateData1 && endDateData1) {
      handleGetCountData();
    }
  }, [
    selectedProductIds,
    startDateData,
    endDateData,
    startDateData1,
    endDateData1,
    showTime,
  ]);

  useEffect(() => {
    if (selectedProductIds.length > 0 && startDateData1 && endDateData1) {
      handleGetLocation();
    }
  }, [selectedProductIds, startDateData1, endDateData1]);

  const buildDateRange = () => {
    return showTime
      ? {
          start_date: startDateData,
          end_date: endDateData,
        }
      : {
          start_date: `${startDateData1} 00:00:00`,
          end_date: `${endDateData1} 23:59:59`,
        };
  };

  const handleGetCountData = async () => {
    const params = {
      product_id: selectedProductIds,
      ...buildDateRange(),
    };

    try {
      const resp = await getScannedPipesCount(params);
      if ([200, 201].includes(resp.status)) {
        setPipesData(resp.data.payload);
      } else {
        setPipesData([]);
      }
    } catch (error) {
      console.error("Error fetching pipe count:", error);
      setPipesData([]);
    } finally {
      setIsFilterOpen(false);
    }
  };

  const handleGetLocation = async () => {
    const params = {
      product_id: selectedProductIds,
      device_types: selectedDevices,
      scan_by: selectRoleId,

      ...buildDateRange(),
    };
    if (selectedBoxes.length > 0) {
      params.supply_chain = selectedBoxes;
    }
    if (selectedScanBoxes.length > 0) {
      params.status_choice = selectedScanBoxes;
    }
    try {
      const resp = await getLocationsForMap(params);
      if ([200, 201].includes(resp.status)) {
        setLocationAPIData(resp.data.payload);
      } else {
        setLocationAPIData([]);
      }
    } catch (error) {
      console.error("Error fetching locations:", error);
      setLocationAPIData([]);
    }
  };

  const handleSubmit = async () => {
    await Promise.all([handleGetCountData(), handleGetLocation()]);
  };

  const getLocationTrackingData = async () => {
    const params = {
      uid: locationSearch,
    };

    try {
      const resp = await getTracking(params);

      if ([200, 201].includes(resp.status)) {
        setUIDSearchData(resp.data.payload);
        if (resp.data.payload?.uid === null) {
          notifyError(resp.data.message);
        }
      } else {
        setUIDSearchData([]);
        notifyError(resp.data.message);
      }
    } catch (error) {
      console.error("Error fetching locations:", error);
      setUIDSearchData([]);
    }
  };

  useEffect(() => {
    if (locationSearch) {
      if (debouncedText.length === 16) {
        getLocationTrackingData();
      } else {
        setUIDSearchData([]);
      }
    } else {
      setUIDSearchData([]);
    }
  }, [debouncedText]);

  return (
    <>
      <Box id="map-container" className="map-div map-container-wrapper">
        {/* Time toggle switch and date range */}
        <Box className="map-controls-left">
          <FormGroup aria-label="position" row>
            <FormControlLabel
              className="time-picker"
              value="top"
              control={
                <Switch
                  color="primary"
                  checked={showTime}
                  sx={{ marginTop: "-11px" }}
                />
              }
              label="Time"
              labelPlacement="top"
              onChange={handleToggleTime}
            />
          </FormGroup>
          <TimeDatePicker
            time={showTime}
            startDateReFormat={startDateReFormat}
            endDateReFormat={endDateReFormat}
            handleStartDate={handleStartDate}
            handleEndDate={handleEndDate}
            Start_Date_lable={"Test Start Date"}
            end_Date_lable={"Test End Date"}
          />
        </Box>

        {/* Location search and filter */}
        <Box className="map-controls-right">
          <div className="map-location">
            <Box className="search-container">
              <input
                type="text"
                placeholder="UID"
                value={locationSearch}
                onChange={(e) => {
                  const value = e.target.value;
                  if (value.length <= 16) {
                    setLocationSearch(value);
                  }
                }}
                maxLength={16}
                className="location-search-input"
              />
              {locationSearch ? (
                <ClearIcon
                  onClick={handleClearSearch}
                  className="search-icon clear"
                />
              ) : (
                <SearchIcon className="search-icon" />
              )}
            </Box>
          </div>
          <ClickAwayListener
            onClickAway={(event) => {
              // Check if the click is inside the filter dropdown
              const filterDropdown = document.querySelector(".filter-dropdown");
              if (filterDropdown && !filterDropdown.contains(event.target)) {
                setIsFilterOpen(false);
              }
            }}
          >
            <div className="map-filter">
              <img
                src={images.filter}
                alt="filter-icon"
                className="filter-icon"
                onClick={handleFilterClick}
              />
              {isFilterOpen && (
                <div className="filter-dropdown">
                  <Box className="filter-title">Filters</Box>
                  <FormGroup className="filter-popup-checkbox">
                    <Box className="filter-section">
                      {product.map((item) => (
                        <FormControlLabel
                          key={item.id}
                          control={
                            <Checkbox
                              checked={selectedProductIds.includes(item.id)}
                              onChange={() => {
                                if (
                                  item.product_name === "Pipe" &&
                                  selectedProductIds.includes(item.id)
                                ) {
                                  // Prevent unchecking "Pipe"
                                  return;
                                }
                                handleFilterChange(item.id)();
                              }}
                              size="small"
                            />
                          }
                          label={item.product_name}
                        />
                      ))}
                    </Box>

                    <Box className="filter-section">
                      <Box className="section-title">Supply Chain</Box>
                      <Box className="supply-chain-container">
                        <Box
                          className={`supply-chain-box ${
                            selectedBoxes.includes("distributor")
                              ? "active-box"
                              : ""
                          }`}
                          onClick={() => handleSupplyChainClick("distributor")}
                        >
                          <img
                            src={
                              selectedBoxes.includes("distributor")
                                ? images.distributor1
                                : images.distributionIcon
                            }
                            alt="distributor"
                            className="filter-icon-small"
                          />
                          <span>Distributor</span>
                        </Box>

                        <Box
                          className={`supply-chain-box ${
                            selectedBoxes.includes("plants") ? "active-box" : ""
                          }`}
                          onClick={() => handleSupplyChainClick("plants")}
                        >
                          <img
                            src={
                              selectedBoxes.includes("plants")
                                ? images.plants
                                : images.factoryIcon
                            }
                            alt="factory"
                            className="filter-icon-small"
                          />
                          <span>Manufacturing Plants</span>
                        </Box>
                      </Box>
                    </Box>

                    <Box className="filter-section">
                      <Box className="section-title">Scan Result</Box>
                      <Box className="scan-result-container">
                        <Box
                          className={`scan-result-box ${
                            selectedScanBoxes.includes(3) ? "active-box" : ""
                          }`}
                          onClick={() => handleScanResult(3)}
                        >
                          <img
                            src={images.redMark}
                            alt="counterfeit"
                            className="filter-icon-small"
                          />
                          <span>Counterfeit</span>
                        </Box>
                        <Box
                          className={`scan-result-box ${
                            selectedScanBoxes.includes(1) ? "active-box" : ""
                          }`}
                          onClick={() => handleScanResult(1)}
                        >
                          <img
                            src={images.greenMark}
                            alt="genuine"
                            className="filter-icon-small"
                          />
                          <span>Genuine</span>
                        </Box>
                      </Box>
                      <Box
                        className={`scan-result-box ${
                          selectedScanBoxes.includes(2) ? "active-box" : ""
                        }`}
                        onClick={() => handleScanResult(2)}
                      >
                        <img
                          src={images.orageIcon}
                          alt="cross selling"
                          className="filter-icon-small"
                        />
                        <span>Cross Selling</span>
                      </Box>
                    </Box>

                    <Box className="filter-section">
                      <Box className="section-title">Scan By:</Box>
                      {roleList.map((role) => {
                        const roleKey = role?.id; // Normalize the key
                        return (
                          <FormControlLabel
                            key={role.id}
                            control={
                              <Checkbox
                                checked={selectRoleId.includes(roleKey)}
                                onChange={handleFilterRoleChange(roleKey)}
                                size="small"
                              />
                            }
                            label={role.name}
                          />
                        );
                      })}
                    </Box>

                    <Box className="filter-section">
                      <Box className="section-title">Device:</Box>
                      <FormControlLabel
                        control={
                          <Checkbox
                            checked={selectedDevices.includes(0)}
                            onChange={handleFilterChangeData(0)}
                            size="small"
                          />
                        }
                        label="Android"
                      />

                      <FormControlLabel
                        control={
                          <Checkbox
                            checked={selectedDevices.includes(1)}
                            onChange={handleFilterChangeData(1)}
                            size="small"
                          />
                        }
                        label="iOS"
                      />
                    </Box>

                    <Button
                      onClick={handleSubmit}
                      title="Submit"
                      classname={"custom-button"}
                    />
                  </FormGroup>
                </div>
              )}
            </div>
          </ClickAwayListener>
        </Box>

        {/* Fullscreen toggle button */}
        {/* <button
          onClick={toggleFullscreen}
          className={`fullscreen-button ${
            isSolarFullScreen ? "fullscreen" : ""
          }`}
        > */}
        {isSolarFullScreen ? (
          // <CloseFullscreenIcon className="fullscreen-icon" />
          <img
            src={images.resizeButton1}
            onClick={toggleFullscreen}
            alt="resize"
            className={`fullscreen-button ${
              isSolarFullScreen ? "fullscreen" : ""
            }`}
          />
        ) : (
          // <OpenInFullIcon className="fullscreen-icon" />
          <img
            src={images.resizeButton}
            onClick={toggleFullscreen}
            alt="resize"
            className={`fullscreen-button ${
              isSolarFullScreen ? "fullscreen" : ""
            }`}
          />
        )}
        {/* </button> */}

        <MapComponent
          isSolarFullScreen={isSolarFullScreen}
          isFullscreen={isFullscreen}
          data={locationAPIData}
          type="Dashboard"
          UIDSearchData={UIDSearchData}
        />
      </Box>
    </>
  );
};

export default MapContainer;
